export default "__VITE_ASSET__Dlxqfh1___"